import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import doneIcon from '../assets/images/done.svg';
import { useClubStore } from '../store/clubStore';
import axiosInstance from '../axiosConfig';
import { useGlobalStore } from '../store/globalStore';
import { useDialogStore } from '../store/dialogStore';

const EditDataPage: React.FC = () => {
  const myClub = useClubStore((state) => state.myClub);
  const setLoading = useGlobalStore((state) => state.setLoading);
  const openDialog = useDialogStore((state) => state.openDialog);

  const [form, setForm] = useState({
    email: '',
    password: '',
    iban: '',
    bic: '',
  });

  useEffect(() => {
    if (myClub) {
      setForm({
        email: myClub.email || '',
        password: '',
        iban: myClub.bank?.iban || '',
        bic: myClub.bank?.bic || '',
      });
    }
  }, [myClub]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  const submit = async () => {
    try {
      setLoading(true);
      await axiosInstance.put('/club', form);
      openDialog(
        <div className="py-5">
          <img className="mx-auto mb-2" src={doneIcon} alt="" />
          <div className="text-md text-center">Erfolgreich aktualisiert.</div>
        </div>,
        () => {},
        true,
      );
    } catch (error) {
      console.error('Error logging in:', error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  return (
    <div className="grid gap-2 items-center mx-5 bg-white p-4 border rounded-md">
      <div className="font-medium text-lg mb-4">Daten ändern</div>

      <div className="flex gap-4 pb-3">
        <div>
          <div className="font-medium text-lg"> {myClub?.name}</div>
          <div> {myClub?.sender_name}</div>
        </div>
      </div>
      <div className="flex gap-4 items-center">
        <div className="w-5 hidden sm:inline-block">🔢</div>
        <div className="w-28">Clubnummer</div>
        <div className="font-medium"> {myClub?.club_number}</div>
      </div>
      <div className="h-4 w-full mt-4 border-t"></div>
      <div className="flex  gap-4 items-center">
        <div className="w-5 hidden sm:inline-block">✉️</div>
        <div className="w-28">E-Mail</div>
        <div>{form.email}</div>
      </div>
      <div className="flex gap-4 items-center">
        <div className="w-5 hidden sm:inline-block">💳</div>
        <div className="w-28">IBAN</div>
        <div>
          <Input
            type="string"
            id="iban"
            placeholder=""
            value={form.iban}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="flex gap-4 items-center">
        <div className="w-5 hidden sm:inline-block">💵</div>
        <div className="w-28">BIC</div>
        <div>
          <Input
            type="string"
            id="bic"
            placeholder=""
            value={form.bic}
            onChange={handleChange}
          />
        </div>
      </div>
      <div>
        <Button onClick={() => submit()} type="submit">
          Daten speichern
        </Button>
      </div>
    </div>
  );
};

export default EditDataPage;
